/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useRef, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import clsx from "clsx";
import { verifyPhoneNumber, RegisterOrLoginFunction, getUserByToken, AddUserToProducerCenterByInvitation } from "../core/_requests";
import { Link } from "react-router-dom";
import { useAuth } from "../core/Auth";
import { useLocation, useNavigate } from "react-router-dom";
import { RedirectToVerifyPhoneNumber } from "../RedirectToVerifyPhoneNumber";
import { LogInSuccessfully } from "../LogInSuccessfully";
import { AuthModel } from "../core/_models";
import { handleFullApiError } from "../../utils/apiUtils";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import LogRocket from 'logrocket';
import { getDeviceOS, getBrowserName, getUserDeviceInfo } from "../../utils/DeviceHelper";
import { useSetUserProducerCenterSpecificationAndWallet } from "../../producerCenter/components/useSetUserProducerCenterSpecificationAndWallet";
import { useTranslation } from 'react-i18next'

const initialValues = {
  phoneNumber: "",
  countryCode: "",
  countryId: 0,
  code: "",
  Password: "",
  AppNameId: "",
  code1: "",
  code2: "",
  code3: "",
  code4: "",
};

export function RegisterOrLogin() {
  const { t } = useTranslation()
  const inputRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const { saveAuth, setCurrentUser, saveUserProducerCenter, saveCurrentUser } = useAuth();
  const locationState = useLocation().state as {
    phoneNumber: string;
    countryCode: string;
    countryId: number;
    appNameId: string;
    inviteCode: string;
  };
  const [countryId, setCountryId] = useState(0);
  const [countryCode, setCountryCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [inviteCode, setInviteCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  const [showWarningMessage, setShowWarningMessage] = useState(false);
  const { currentUser } = useAuth();
  const { setUserProducerCenterSpecificationAndWallet } = useSetUserProducerCenterSpecificationAndWallet();

  const showSwal = () => {
    withReactContent(Swal).fire({
      title: <i>{t("AUTH.REGISTER_LOGIN.INVITE_CONFIRMED")}</i>,
      timer: 3000,
      icon: "success",
      showConfirmButton: true,
      confirmButtonText: t("AUTH.REGISTER_LOGIN.OK"),
    });
  };

  const registerOrLoginSchema = Yup.object().shape({
    code1: Yup.string()
      .matches(/^\d$/, t("AUTH.REGISTER_LOGIN.CODE_DIGIT_ONLY"))
      .required(t("AUTH.REGISTER_LOGIN.CODE_FIRST_REQUIRED")),
    code2: Yup.string()
      .matches(/^\d$/, t("AUTH.REGISTER_LOGIN.CODE_DIGIT_ONLY"))
      .required(t("AUTH.REGISTER_LOGIN.CODE_SECOND_REQUIRED")),
    code3: Yup.string()
      .matches(/^\d$/, t("AUTH.REGISTER_LOGIN.CODE_DIGIT_ONLY"))
      .required(t("AUTH.REGISTER_LOGIN.CODE_THIRD_REQUIRED")),
    code4: Yup.string()
      .matches(/^\d$/, t("AUTH.REGISTER_LOGIN.CODE_DIGIT_ONLY"))
      .required(t("AUTH.REGISTER_LOGIN.CODE_FOURTH_REQUIRED")),
  });

  const [timeLeft, setTimeLeft] = useState(120); // Default to 2 minutes
  const [showSendCodeButton, setShowSendCodeButton] = useState(false);

  const code1Ref = useRef<HTMLInputElement>(null);
  const code2Ref = useRef<HTMLInputElement>(null);
  const code3Ref = useRef<HTMLInputElement>(null);
  const code4Ref = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false);
  const [showLoginSuccessfullyModal, setShowLoginSuccessfullyModal] = useState<boolean>(false);

  const code1Handler = (event) => {
    let code1Value = event.target.value;
    if (event.key === "Backspace" && !code1Value) {
      code1Ref.current?.focus();
      formik.setFieldValue("code1", "");
      return;
    }
    if (code1Value.length == 1) {
      code2Ref.current?.focus();
    }
    if (code1Value.length > 1) {
      const lastChar = code1Value.charAt(code1Value.length - 1);
      formik.setFieldValue("code1", lastChar);
      code2Ref.current?.focus();
    }
  };

  const code2Handler = (event) => {
    let code2Value = event.target.value;
    if (event.key === "Backspace" && !code2Value) {
      code1Ref.current?.focus();
      formik.setFieldValue("code2", "");
      return;
    }
    if (code2Value.length == 1) {
      code3Ref.current?.focus();
    }
    if (code2Value.length > 1) {
      const lastChar = code2Value.charAt(code2Value.length - 1);
      formik.setFieldValue("code2", lastChar);
      code3Ref.current?.focus();
    }
  };

  const code3Handler = (event) => {
    let code3Value = event.target.value;
    if (event.key === "Backspace" && !code3Value) {
      code2Ref.current?.focus();
      formik.setFieldValue("code3", "");
      return;
    }
    if (code3Value.length == 1) {
      code4Ref.current?.focus();
    }
    if (code3Value.length > 1) {
      const lastChar = code3Value.charAt(code3Value.length - 1);
      formik.setFieldValue("code3", lastChar);
      code4Ref.current?.focus();
    }
  };

  const code4Handler = (event) => {
    let code4Value = event.target.value;
    if (event.key === "Backspace" && !code4Value) {
      code3Ref.current?.focus();
      formik.setFieldValue("code4", "");
      return;
    }
    if (code4Value.length == 1) {
      code4Ref.current?.blur();
    }
    if (code4Value.length > 1) {
      const lastChar = code4Value.charAt(code4Value.length - 1);
      formik.setFieldValue("code4", lastChar);
      code4Ref.current?.blur();
    }
    formik.submitForm();
  };

  const sendVerifyCodeAgain = async () => {
    // Call your verification API
    const verifyPhoneNumberResult = await verifyPhoneNumber(
      locationState.countryId,
      locationState.phoneNumber,
      locationState.countryCode
    );

    if (verifyPhoneNumberResult.data?.isSuccess === false) {
      let message = JSON.parse(verifyPhoneNumberResult.data.message);
      if (message.length >= 1) {
        let messageShow = message[0].Value.DefaultMessage;
        if (verifyPhoneNumberResult.data.requestId != null) {
          messageShow = messageShow + "\n " + t("AUTH.VERIFY.ERROR_CODE") + " : " + verifyPhoneNumberResult.data.requestId;
        }
        // Warning
        if (verifyPhoneNumberResult.data.returnType == 2) {
          setWarningMessage(messageShow);
          setShowWarningMessage(true);
        }
        // Error
        else if (verifyPhoneNumberResult.data.returnType == 3) {
          setErrorMessage(messageShow);
          setShowErrorMessage(true);
        }
      } else {
        let messageShow = message.Value.DefaultMessage;
        if (verifyPhoneNumberResult.data.requestId != null) {
          messageShow = messageShow + "\n " + t("AUTH.VERIFY.ERROR_CODE") + " : " + verifyPhoneNumberResult.data.requestId;
        }
        // Warning
        if (verifyPhoneNumberResult.data.returnType == 2) {
          setWarningMessage(messageShow);
          setShowWarningMessage(true);
        }
        // Error
        else if (verifyPhoneNumberResult.data.returnType == 3) {
          setErrorMessage(messageShow);
          setShowErrorMessage(true);
        }
      }
      return false;
    } else if (verifyPhoneNumberResult.data?.isSuccess === undefined) {
      setErrorMessage(`${t("AUTH.VERIFY.SEND_CODE_ERROR")} : \n ${verifyPhoneNumberResult}`);
      setShowErrorMessage(true);
      return false;
    }

    setTimeLeft(120);

    const newStartTime = Date.now();
    localStorage.setItem("startTime", newStartTime.toString());

    setShowSendCodeButton(false);
  };

  useEffect(() => {
    if (
      locationState == null ||
      locationState.countryId === 0 ||
      locationState.phoneNumber === "" ||
      locationState.countryId === 0 ||
      locationState.appNameId === ""
    ) {
      setShowCreateAppModal(true);
      const delay = 5000;
      const timeoutId = setTimeout(() => {
        navigate("/auth/verify-phonenumber");
      }, delay);
      return () => clearTimeout(timeoutId);
    } else {
      setCountryId(locationState.countryId);
      setCountryCode(locationState.countryCode);
      setPhoneNumber(locationState.phoneNumber);
    }

    setInviteCode(locationState.inviteCode);

    const originalTitle = document.title;
    document.title = `${originalTitle} | ${t("AUTH.REGISTER_LOGIN.VERIFY_CODE_TITLE")}`;
    return () => {
      document.title = originalTitle; // Reset the title
    };
  }, [locationState, navigate, t]);

  useEffect(() => {
    const storedTime = localStorage.getItem("startTime");

    const startTime = storedTime ? new Date(parseInt(storedTime)).getTime() : 0;
    const currentTime = Date.now();
    const timeElapsed = Math.floor((currentTime - startTime) / 1000);
    const remainingTime = 120 - timeElapsed; // 120 seconds = 2 minutes

    if (remainingTime > 0) {
      setTimeLeft(remainingTime);
    } else {
      setShowSendCodeButton(true);
    }
  }, []);

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);

      return () => clearInterval(timer);
    } else {
      setShowSendCodeButton(true);
    }
  }, [timeLeft]);

  useEffect(() => {
    if (code1Ref.current) {
      code1Ref.current.focus();
    }
  }, []);
  const formik = useFormik({
    initialValues,
    validationSchema: registerOrLoginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      try {
        var countryCode = locationState.countryCode;
        var phoneNumber = locationState.phoneNumber;
        var countryId = locationState.countryId;
        var appNameId = locationState.appNameId;
        var code = values.code1 + values.code2 + values.code3 + values.code4;

        var deviceOS = getDeviceOS()
        var deviceBrowser = getBrowserName()
        var deviceName = getUserDeviceInfo()

        const registerOrLoginResult = await RegisterOrLoginFunction(
          countryId,
          phoneNumber,
          countryCode ?? "",
          code,
          values.Password,
          appNameId,
          20,
          deviceOS,
          deviceBrowser,
          deviceName
        );
        if (registerOrLoginResult.data?.isSuccess) {
          const authData: AuthModel = {
            token: registerOrLoginResult.data.data.token,
            refreshToken: "",
            createDate: new Date().getTime(), // Current date
          };
          saveAuth(authData);
          LogRocket.identify('USER_ID', {
            name: locationState.phoneNumber,
          });
          
          if (locationState.inviteCode) {
            let results = await AddUserToProducerCenterByInvitation(
              locationState.inviteCode
            );
            if (results.data?.isSuccess === true) {
              showSwal();
            } else {
              handleFullApiError(
                results,
                setWarningMessage,
                setShowWarningMessage,
                setErrorMessage,
                setShowErrorMessage,
                t("AUTH.REGISTER_LOGIN.INVITE_CHECK_ERROR")
              );
            }
          }
          setUserProducerCenterSpecificationAndWallet();
          // var getUserProducerCenter = await GetUserProducerCenterT(
          //   registerOrLoginResult.data.data.token
          // );
          // if (getUserProducerCenter.data?.isSuccess == true) {
          //   const userProducerCenter: UserProducerCenter = {
          //     producerCenterId:
          //       getUserProducerCenter.data.data.producerCenterId,
          //     name: getUserProducerCenter.data.data.name,
          //     code: getUserProducerCenter.data.data.code,
          //     icon: getUserProducerCenter.data.data.icon,
          //     isMaster: getUserProducerCenter.data.data.isMaster,
          //     walletPrice: 0,
          //   };
          //   var getProducerCenterWallet = await GetProducerCenterWalletPriceT(
          //     getUserProducerCenter.data.data.producerCenterId,
          //     registerOrLoginResult.data.data.token
          //   );
          //   if (getProducerCenterWallet.data?.isSuccess == true) {
          //     userProducerCenter.walletPrice =
          //       getProducerCenterWallet.data.data.walletPrice;
          //   }
          //   saveUserProducerCenter(userProducerCenter);
          // }
          const { data: user } = await getUserByToken(
            registerOrLoginResult.data.data.token
          );
          if (localStorage.getItem("startTime")?.length ?? 0 > 0) {
            localStorage.removeItem("startTime");
          }
          setShowLoginSuccessfullyModal(true);
          const delay = 5000;
          const timeoutId = setTimeout(() => {
            //setCurrentUser(user.data)
            saveCurrentUser(user.data);
            //navigate('/auth/verify-phonenumber')
          }, delay);
          return () => clearTimeout(timeoutId);
        } else if (registerOrLoginResult.data?.isSuccess == false) {
          saveAuth(undefined);
          let message = JSON.parse(registerOrLoginResult.message);
          if (message.length > 1) {
            setStatus(message[0].Value.DefaultMessage);
          } else {
            setStatus(message.Value.DefaultMessage);
          }
          setSubmitting(false);
          setLoading(false);
          return false;
        } else {
          saveAuth(undefined);
          setStatus(`${t("AUTH.REGISTER_LOGIN.LOGIN_REGISTER_ERROR")} ${registerOrLoginResult}`);
          setSubmitting(false);
          setLoading(false);
        }
      } catch (error) {
        saveAuth(undefined);
        setStatus(t("AUTH.VERIFY.UNKNOWN_ERROR"));
        setSubmitting(false);
        setLoading(false);
      }
    },
  });

  return (
    <form
      className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
      noValidate
      id="kt_login_signup_form"
      onSubmit={formik.handleSubmit}
    >
      {/* begin::Heading */}
      <div className="text-center mb-11">
        {/* begin::Title */}
        <h1 className="text-dark fw-bolder mb-3">{t("AUTH.REGISTER_LOGIN.VERIFY_CODE_TITLE")}</h1>
        {/* end::Title */}
      </div>
      {/* end::Heading */}

      {formik.status && (
        <div className="mb-lg-15 alert alert-danger">
          <div className="alert-text font-weight-bold">{formik.status}</div>
        </div>
      )}

      {/* begin alert message */}
      {showErrorMessage ? (
        <div className="alert alert-danger d-flex align-items-center p-5 mb-10">
          <span className="svg-icon svg-icon-2hx svg-icon-danger me-3"></span>
          <div className="d-flex flex-column">
            <span>{errorMessage}</span>
          </div>
        </div>
      ) : null}
      {showWarningMessage ? (
        <div className="alert alert-warning d-flex align-items-center p-5 mb-10">
          <span className="svg-icon svg-icon-2hx svg-icon-warning me-3"></span>
          <div className="d-flex flex-column">
            <span>{warningMessage}</span>
          </div>
        </div>
      ) : null}
      {/* end alert */}

      {/* begin::Form group Code */}
      <div className="fv-row mb-8 text-center">
        <div className="verifyCodeLine">
          <input
            ref={code4Ref}
            type="text"
            autoComplete="off"
            {...formik.getFieldProps("code4")}
            onKeyUp={code4Handler}
            inputMode="numeric"
            pattern="[0-9]*"
            className={clsx("form-control bg-transparent verifyCodeBox", {
              "is-invalid": formik.touched.code4 && formik.errors.code4,
            })}
          />
          <input
            ref={code3Ref}
            type="text"
            autoComplete="off"
            {...formik.getFieldProps("code3")}
            onKeyUp={code3Handler}
            inputMode="numeric"
            pattern="[0-9]*"
            className={clsx("form-control bg-transparent verifyCodeBox", {
              "is-invalid": formik.touched.code3 && formik.errors.code3,
            })}
          />
          <input
            ref={code2Ref}
            type="text"
            autoComplete="off"
            {...formik.getFieldProps("code2")}
            onKeyUp={code2Handler}
            inputMode="numeric"
            pattern="[0-9]*"
            className={clsx("form-control bg-transparent verifyCodeBox", {
              "is-invalid": formik.touched.code2 && formik.errors.code2,
            })}
          />
          <input
            ref={code1Ref}
            type="text"
            autoComplete="off"
            {...formik.getFieldProps("code1")}
            onKeyUp={code1Handler}
            inputMode="numeric"
            pattern="[0-9]*"
            className={clsx("form-control bg-transparent verifyCodeBox", {
              "is-invalid": formik.touched.code1 && formik.errors.code1,
            })}
          />
        </div>
        {formik.touched.code && formik.errors.code && (
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              <span role="alert">{formik.errors.code}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className="text-center">
        <button
          type="submit"
          id="kt_sign_up_submit"
          className="btn btn-lg btn-main w-100 mb-5"
        // disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className="indicator-label">{t("AUTH.REGISTER_LOGIN.CONFIRM")}</span>}
          {loading && (
            <span className="indicator-progress display-block">
              {t("AUTH.PLEASE_WAIT")}{" "}
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          )}
        </button>
        <Link
          to={
            inviteCode != ""
              ? `/auth/verify-phonenumber?code=${inviteCode}`
              : "/auth/verify-phonenumber"
          }
        >
          <button
            type="button"
            id="kt_login_signup_form_cancel_button"
            className="btn btn-lg btn-light-main w-100 mb-5"
            onClick={() => {
              if (localStorage.getItem("startTime")?.length ?? 0 > 0) {
                localStorage.removeItem("startTime");
              }
            }}
          >
            {t("AUTH.GENERAL.BACK_BUTTON")}
          </button>
        </Link>
        {/* <p>Didnt get a code</p> */}
        {showSendCodeButton ? (
          <a className="px-5 link main-link" onClick={sendVerifyCodeAgain}>
            {t("AUTH.REGISTER_LOGIN.RESEND_CODE")}
          </a>
        ) : (
          <div>
            <div>
              {Math.floor(timeLeft / 60)}:{timeLeft % 60}
            </div>
            <label> {t("AUTH.REGISTER_LOGIN.UNTIL_RESEND_CODE")} </label>
          </div>
        )}
        <RedirectToVerifyPhoneNumber
          show={showCreateAppModal}
          handleClose={() => setShowCreateAppModal(false)}
        />
        <LogInSuccessfully
          show={showLoginSuccessfullyModal}
          handleClose={() => setShowLoginSuccessfullyModal(false)}
        />
      </div>
      {/* end::Form group */}
    </form>
  );
}
